import { Link } from 'react-router'
import { MessageSquare } from 'lucide-react'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { CardSkeleton } from '@/components/loading'
import { cn } from '@/utils'
import { useAiAssistantWidget } from './AiAssistantWidget.logic'

export function AiAssistantWidget() {
  const { t, status, isLoading, usagePercent, resetDate } = useAiAssistantWidget()

  if (isLoading) {
    return <CardSkeleton />
  }

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>{t('aiAssistant')}</CardTitle>
        <div className="rounded-lg bg-purple-500/10 p-2">
          <MessageSquare className="size-4 text-purple-500" />
        </div>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex items-center gap-2">
          <div
            className={cn(
              'size-2.5 rounded-full',
              status?.available ? 'bg-green-500' : 'bg-red-500'
            )}
          />
          <span className="text-sm">
            {status?.available ? t('chatAvailable') : t('chatUnavailable')}
          </span>
        </div>

        {status && (
          <div className="space-y-2">
            <div className="flex items-center justify-between text-sm">
              <span className="text-muted-foreground">{t('monthlyLimit')}</span>
              <span className="font-medium">{usagePercent}%</span>
            </div>
            <div className="h-2 overflow-hidden rounded-full bg-muted ring-1 ring-border">
              <div
                className={cn(
                  'h-full rounded-full transition-all',
                  usagePercent > 90
                    ? 'bg-red-500'
                    : usagePercent > 50
                      ? 'bg-yellow-500'
                      : 'bg-green-500'
                )}
                style={{ width: `${usagePercent}%` }}
              />
            </div>
            <p className="text-xs text-muted-foreground">{t('resetsOn', { date: resetDate })}</p>
          </div>
        )}

        <Button className="w-full" asChild>
          <Link to="/chat">
            <MessageSquare className="mr-2 size-4" />
            {t('startConversation')}
          </Link>
        </Button>
      </CardContent>
    </Card>
  )
}
